<template>
  <ol v-if="totalSteps" class="steps">
    <li
      v-for="step in steps"
      :key="step"
      :class="['step', { reached: step <= currentStep }]"
    />
  </ol>
</template>

<script>
import { integer } from "vue-types";

export default {
  name: "ProgressSteps",
  props: {
    currentStep: integer().def(1),
    totalSteps: integer().def(undefined),
  },
  computed: {
    steps() {
      return Array.from(
        { length: this.totalSteps },
        (_value, index) => index + 1
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/_all-members" as global;

.steps {
  display: flex;
  margin: 0 !important;
}

.step {
  display: inline-block;
  width: 3.33rem;
  height: 0.2rem;
  margin: 0 !important;
  border-radius: 10rem;
  background: #d6d6d6;

  &:not(:last-child) {
    margin-right: 0.33rem !important;
  }

  &.reached {
    background: global.$positive;
  }
}
</style>
